let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aiKfZ")).then(() => parcelRequire('eRtVx'));